import { render, staticRenderFns } from "./flash-messages.vue?vue&type=template&id=5400ede3&"
import script from "./flash-messages.vue?vue&type=script&lang=js&"
export * from "./flash-messages.vue?vue&type=script&lang=js&"
import style0 from "./flash-messages.vue?vue&type=style&index=0&id=5400ede3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports